import { STOfPieType, STSplitType, SubChartType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import { BaseSubChart } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/base-sub-chart';
import { PresetChartType } from '../chart-presets/const';
import type { IOfPieChart } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart';
import type { IChartLine } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-properties.interface';

export class OfPieChart extends BaseSubChart implements IOfPieChart {
    public static convertDataUiToSdk(uiData, sdkData, rawUiData): void {
        this.convertSubChartUiToSdkByType(SubChartType.OfPieChart, uiData, sdkData, rawUiData);
    }

    public type = SubChartType.OfPieChart;
    /**
     * 子母图类型，值为pie或bar
     */
    public ofPieType?: STOfPieType;
    /**
     * 子母图之间的间隙, 百分比
     */
    public gapWidth?: number;
    /**
     * 系列分隔依据，分为auto, cust, percent, pos, val五种
     */
    public splitType?: STSplitType;
    /**
     * 第二个图百分比大小
     */
    public secondPieSize?: number;
    /**
     * 系列按位置或值或百分比进行分割时，值的大小
     */
    public splitPos?: number;
    /**
     * 系列按自定义进行分割时，第二个图points索引值
     */
    public secondPiePts?: number[];
    /**
     * 系列线，连接图形的线样式
     */
    public serLines?: IChartLine[];

    public getPresetChartType(): PresetChartType {
        switch (this.ofPieType) {
            case STOfPieType.bar:
                return PresetChartType.OF_PIE_BAR;
            default:
                return PresetChartType.OF_PIE;
        }
    }
}
